import useAxios from "../../hooks/useAxios";

const usePrismSubscriptionService = () => {
  const axiosSubscriptions = useAxios();
  const axiosSubscriptionExport = useAxios();
  const axiosCreateSubscription = useAxios();
  const axiosUpdateSubscription = useAxios();
  const axiosUpdateSubscriptionActivation = useAxios();
  const axiosDeleteSubscription = useAxios();

  const getSubscriptions = async () => {
    await axiosSubscriptions.fetchData({
      url: "/prism/subscriptions",
      method: "GET",
    });
  };

  const getSubscriptionExportData = async () => {
    await axiosSubscriptionExport.fetchData({
      url: "/prism/subscriptions/export-data",
      method: "GET",
    });
  };

  const createSubscription = async (data) => {
    return await axiosCreateSubscription.fetchData({
      url: "/prism/subscriptions",
      method: "POST",
      data,
    });
  };

  const updateSubscription = async (id, data) => {
    return await axiosUpdateSubscription.fetchData({
      url: `/prism/subscriptions/${id}`,
      method: "PUT",
      data,
    });
  };

  const updateSubscriptionActivation = async (id, enabled) => {
    return await axiosUpdateSubscriptionActivation.fetchData({
      url: `/prism/subscriptions/${id}/activation`,
      method: "PATCH",
      data: { enabled },
    });
  };

  const deleteSubscription = async (id) => {
    return await axiosDeleteSubscription.fetchData({
      url: `/prism/subscriptions/${id}`,
      method: "DELETE",
    });
  };

  return {
    getSubscriptions,
    subscriptionLoading: axiosSubscriptions.loading,
    subscriptionResponse: axiosSubscriptions.response,
    subscriptionError: axiosSubscriptions.error,
    getSubscriptionExportData,
    subscriptionExportLoading: axiosSubscriptionExport.loading,
    subscriptionExportResponse: axiosSubscriptionExport.response,
    subscriptionExportError: axiosSubscriptionExport.error,
    createSubscription,
    createLoading: axiosCreateSubscription.loading,
    createError: axiosCreateSubscription.error,
    updateSubscription,
    updateLoading: axiosUpdateSubscription.loading,
    updateError: axiosUpdateSubscription.error,
    updateSubscriptionActivation,
    activationLoading: axiosUpdateSubscriptionActivation.loading,
    activationError: axiosUpdateSubscriptionActivation.error,
    deleteSubscription,
    deleteLoading: axiosDeleteSubscription.loading,
    deleteError: axiosDeleteSubscription.error,
  };
};

export default usePrismSubscriptionService;
